import React from "react";

const UpdateApi = ({ formData, handleChange, handleSubmit, onCancel, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Automation</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Slug */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
            required
          />
        </div>

        {/* API */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">API</label>
          <input
            type="text"
            name="api"
            value={formData.api}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter API URL"
            required
          />
        </div>

        {/* List */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">List</label>
          <textarea
            name="list"
            value={formData.list}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter list"
            required
          />
        </div>

        {/* Submit Button */}
           <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Automation"}
            </button>
        </div>
        
      </form>
    </div>
  );
};

export default UpdateApi;
